import { fg } from '@atlassian/jira-feature-gating';

const IsRemoveJswddFetchOperationEnabledRelayProvider = {
	get(): boolean {
		return fg('jpx-1073-remove-jswddfetchoperation');
	},
};

export default IsRemoveJswddFetchOperationEnabledRelayProvider;
